export type CreationAttempt<T> = { id: string; fingerprint: string; body: T };

// Reuse the id for an identical retry after a lost response. Changed content
// starts a separate creation, rather than conflicting with the first record.
export function prepareCreationAttempt<T>(
  body: T,
  previous: CreationAttempt<T> | null,
  createId: () => string,
): CreationAttempt<T> {
  const fingerprint = JSON.stringify(body);
  return previous?.fingerprint === fingerprint
    ? previous
    : { id: createId(), fingerprint, body };
}
